import { render, staticRenderFns } from "./el-card.vue?vue&type=template&id=3dca0656"
import script from "./el-card.vue?vue&type=script&lang=js"
export * from "./el-card.vue?vue&type=script&lang=js"
import style0 from "./el-card.vue?vue&type=style&index=0&id=3dca0656&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports